define('lib/progress-component/percent-complete',['require','exports','module','api-access'],function (require, exports, module) {
    var userApi = require('api-access').user;

    function getPercentCompleted() {
        // we are operating under the assumption that user must have a profile to even see GSU
        // Person Room Step is always completed
        var hasProfile = true;

        return userApi.settings().then(function (settings) {
            var steps = [
                hasProfile,
                settings.hasScheduledMeeting,
                settings.hasExploredAudioOptions,
                settings.hasStartedMeeting,
                settings.hasIntegratedCalendar
            ];
            var delta = 100 / steps.length;

            return steps.reduce(function (prev, curr) {
                return curr ? prev + delta : prev;
            }, 0);
        });
    }

    module.exports = getPercentCompleted;
});

